module.exports = __webpack_public_path__ + "static/media/magazine.a9d18760.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/arts-and-culture/magazine.png
// module id = 77
// module chunks = 0